import api from './api';

const studentService = {
    // Profile
    getProfile: async () => {
        const response = await api.get('/student/profile');
        return response.data;
    },

    updateProfile: async (profileData) => {
        const response = await api.put('/student/profile', profileData);
        return response.data;
    },

    changePassword: async (passwordData) => {
        const response = await api.post('/student/change-password', passwordData);
        return response.data;
    },

    // Notifications
    getNotifications: async () => {
        const response = await api.get('/student/notifications');
        return response.data;
    },

    markNotificationRead: async (notificationId) => {
        const response = await api.post(`/student/notifications/${notificationId}/read`);
        return response.data;
    },

    markAllNotificationsRead: async () => {
        const response = await api.post('/student/notifications/read-all');
        return response.data;
    },

    // Dashboard
    getDashboard: async () => {
        const response = await api.get('/student/dashboard');
        return response.data;
    },

    // My Uploads
    getMyUploads: async (status = 'all', page = 1, limit = 12) => {
        const params = new URLSearchParams({ page, limit });
        if (status !== 'all') {
            params.append('status', status);
        }
        const response = await api.get(`/student/my-uploads?${params.toString()}`);
        return response.data;
    },

    // Backpack (Favorites)
    getBackpack: async () => {
        const response = await api.get('/student/backpack');
        return response.data;
    },

    addToBackpack: async (paperId) => {
        const response = await api.post(`/student/backpack/${paperId}`);
        return response.data;
    },

    removeFromBackpack: async (paperId) => {
        const response = await api.delete(`/student/backpack/${paperId}`);
        return response.data;
    },

    checkBackpack: async (paperId) => {
        const response = await api.get(`/student/backpack/check/${paperId}`);
        return response.data;
    },

    // Feedback
    submitFeedback: async (feedbackData) => {
        const response = await api.post('/student/feedback', feedbackData);
        return response.data;
    },

    getMyFeedback: async () => {
        const response = await api.get('/student/feedback');
        return response.data;
    }
};

export default studentService;
